// extracted by mini-css-extract-plugin
export default {"TabMenu":"TabMenu_TabMenu__jjYJ1","Tabs":"TabMenu_Tabs__mItXb","TabContent":"TabMenu_TabContent__FoH8o"};